(() => {
  if (window.swinger.config.productDeliveryType !== 'vod') {
    return;
  }

  window.swinger.observer.initialize('.swinger-movie-box[data-itemnumber]', (elem) => {
    const itemNumber = elem.getAttribute('data-itemnumber');
    const setClasses = () => {
      const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
      elem.classList[itemOwnState === false ? 'remove' : 'add']('swinger-movie-box--is-owned');
      elem.classList[itemOwnState.status === 'purchased' ? 'add' : 'remove']('swinger-movie-box--is-bought');
      elem.classList[itemOwnState.status === 'rented' ? 'add' : 'remove']('swinger-movie-box--is-rented');
      elem.classList[itemOwnState.status === 'blocked' ? 'add' : 'remove']('swinger-movie-box--is-blocked');
    };

    document.addEventListener('swinger.user:authchange', setClasses);

    setClasses();
  }, false);
})();
